import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { Menu} from '../menu';
import { Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../core/services/auth.service';
import * as $ from 'jquery';
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from '../../../../../core/utils/config-service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    imports: [RouterModule],
    styleUrls: ['./menu.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit {
  @ViewChild('contentMenu') contentMenu:TemplateRef<any> | undefined
  menu:any[]=[]
  periods:any[]=[]
  permissions:any[]=[]
  windows:any[]=[]
  cycles:any[]=[]
  role:any
  user:any
  roles:any[]=[]
  currentRoleIndex=0;
  today= new Date()
  router:any
  lastId:any
  lastId2:any
  filteredKey=["professors-tasklists","professors-note-create","professors-note-index","professors-appreciation","professors-bulletin","professors-bulletin-appreciation"]
  fileSrc="assets/avatar.jpg"
  
  constructor(
    private authService:AuthService,
    private modalService:NgbModal,
     router: Router,
    private toastr:ToastrService,
    private lsService:LocalStorageService,
    private offcanvasService: NgbOffcanvas,

  ) { 
    this.router=router
  }

  ngOnInit(): void {
    this.user=this.lsService.get(GlobalName.userName)
    this.roles=this.user.roles
    this.cycles=this.lsService.get(GlobalName.features).cycles
     this.user=this.lsService.get(GlobalName.userName)
     console.log( this.user)
    if(this.user.photo!=null) this.fileSrc=`${ConfigService.toFile('storage/avatars')}/${this.user.photo}`
    this.loadMenu()
    // this.role=this.user.roles[0].name
    // if(this.user.professor?.cycles.length!=0){
    //   let features=this.lsService.get(GlobalName.features);

    //   let checkIfDE=this.user.professor?.cycles?.find((el:any)=>el.tag ==features[3] || el.tag ==features[4])
    //   if (checkIfDE) {
    //     this.menu=Menu

    //   } else {
    //     this.menu=Menu2

    //   }
    // }


      // this.menu.forEach((el:any, index:any)=>{
      //   if (!el.isTitle) {
      //     this.menu[index].status=this.hasRight(el.name)
      //     if( this.menu[index].hasChildren){
      //       this.menu[index].children.forEach((el2:any, index2:any)=>{ 
      //         this.menu[index].children[index2].status=this.hasRight(el2.name)
      //       })

      //       this.menu[index].status =  this.menu[index].children.filter((el:any)=>el.status == true).length==0?false:true
      //     }
      //   }
       
      // })
      // console.log( this.menu)

    // this.user=this.lsService.get(GlobalName.userName)
    // this.role=this.user.roles[0].name
    // console.log(this.role)
    // switch (this.role) {
    //   case 'Admin':
    //     this.menu=AdminMenu

    //     break;
    //     case 'Admin Sectoriel':
    //       this.menu=AdminSecMenu

    //       break;
    
    //     case 'Saisie':
    //       this.menu=SaisieMenu
    //     this.loadPeriodicitySubMenu()
    //       break;
    
    //     case 'Validation':
    //       this.menu=ValidationMenu
    //       this.loadPeriodicitySubMenu()

    //       break;
    
    //   default:
    //     this.menu=[]
    //     break;
    // }
  
  }

  loadMenu(){
    this.permissions=this.user.roles[this.currentRoleIndex]?.permissions;
    this.windows=this.user.windows.filter((el:any)=> el.role_id== this.user.roles[this.currentRoleIndex].id);
 
    this.menu=this.reinitMenu();
    console.log(this.menu);
    this.menu.forEach((el:any)=>{
      let majorStatus=false
      el.elements.forEach((el2:any)=>{
       if (el2.hasChildren) {
          el2.children.forEach((el3:any)=>{ 
            let check=this.windows.find((w:any)=>w.key==el3.key)
            let status=check!=undefined?true:false
            let verifyCycle=this.user?.professor?.cycles.filter((el:any)=> el.tag == this.cycles[0] || el.tag == this.cycles[1] || el.tag == this.cycles[2])
            //this.filteredKey.find((el)=>el == el3.key) 
            if ((verifyCycle.length ==0 && el3.key=="professors-follow-up")||(verifyCycle.length !=0 && this.filteredKey.find((el)=>el == el3.key) )) {
              el3.status=false
              status=false
            }else{
              console.log(el3.key)

              el3.status=status
            
            }
             if(status){
                el2.status=status
                majorStatus=true
              }
          })
       } else {
        let check=this.windows.find((w:any)=>w.key==el2.key);
        let status=check!=undefined?true:false
        el2.status=status
        if(status){
          el2.status=status
          majorStatus=true
        }
       }
      })
      el.status=majorStatus
    })

  }

  reinitMenu(){
    let menu =Menu;
    this.menu.forEach((el:any,index:any)=>{
      el.elements.forEach((el2:any,index2:any)=>{
       if (el2.hasChildren) {
          el2.children.forEach((el3:any,index3:any)=>{ 
            this.menu[index].elements[index2].children[index3].status=false
          })
       } else {
        this.menu[index].elements[index2].status=false
       }
      })
      this.menu[index].status=false
    })

    return menu;
  }

  hasRight(name:any){
    let check= this.permissions.filter((el:any)=>el.name.toLowerCase().includes(name.toLowerCase()))
    //return check.length==0?false:true
    return true
  }

 
  logout(){
    this.authService.logout().subscribe((res:any)=>{
      this.offcanvasService.dismiss()
      this.modalService.dismissAll()
      this.lsService.remove(GlobalName.tokenName)
      this.lsService.remove(GlobalName.refreshTokenName)
      this.lsService.remove(GlobalName.expireIn)
      this.lsService.remove(GlobalName.userName)
      this.lsService.remove(GlobalName.exercice)
      this.offcanvasService.dismiss()
      this.router.navigate(['/admin/login'])
      this.toastr.success('Déconnexion réussie', 'Connexion');
    }),
    (err:any)=>{
      console.log(err)
      this.toastr.success('Déconnexion échouée', 'Connexion');

    } ;
  }

  setActive(id:any){
    this.lastId='#'+id;
    localStorage.setItem('lastId',this.lastId)
    this.closeMenu()
  }


  setActive2(id:any){
    this.lastId2='#'+id;
    localStorage.setItem('lastId2',this.lastId2)
    this.closeMenu()
  }

  closeMenu(){
    let closeMenuBtn:HTMLElement = document.getElementById('closeMenuBtn') as HTMLElement;
    closeMenuBtn?.click()

  }

  openMenu(){
    this.offcanvasService.open(this.contentMenu,{  panelClass: 'details-panel',position:'end'});
    setTimeout(() => {
    }, 500);

  }
}
